/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable no-console */
/* eslint-disable react/button-has-type */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
// import EmailIcon from "@mui/icons-material/Email";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PhoneIcon from "@mui/icons-material/Phone";
// import SearchIcon from "@mui/icons-material/Search";
import { Box, TableCell, TableRow, Tooltip } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Delete } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useSearchParams } from "react-router-dom";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import { AlertStatus, Constants, PERMISSIONS } from "../../../contants";
import Loader from "../../../components/common/Loader/Loader";
import { CommonStyles } from "../../../components/common/Button/commonButtonStyle";
import style from "./listStyles";
import { performOperation } from "../../member/MemberSearch/utils";
import NewTable from "../../member/components/Newtable/NewTable";
import useUserConfig from "../../../hooks/useUserConfig";
import Typography from "../../../components/common/new/Typography/Typography";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import Alert from "../../../components/common/new/Alert/Alert";
// import ViewTemplate from "../Components/Modal/ViewTemplate";
import styles from "./style";
import Button from "../../../components/common/Button";
import AddIcon from "../../../assets/svg/AddIcon";
import FilesModal from "../Modals";
import Files from "../../../services/api/files";
import UpdateModal from "../Modals/UpdateModal";

const DOCUMENTS_COL = [
  {
    displayName: "S.No.",
  },
  {
    displayName: "Document Name",
  },
  {
    displayName: "Category",
  },
  {
    displayName: "Uploaded By",
  },
  {
    displayName: "uploaded At",
  },
  {
    displayName: "Action",
  },
];

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const LOADER_DELAY = 1000;
const DEFAULT_PAGE_SIZE = 5;

function FilesList() {
  const [TemplateData, setTemplateData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalDownloadPages, setTotalPages] = useState(0);
  const [totalTemplateElements, setTotalElements] = useState(0);
  const [downloadSize, setSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const hasPermission = useUserConfig();
  const [isLoading, setIsLoading] = useState(false);
  //   const dispatch = useDispatch();
  const toast = useContext(ToastAlertContext);
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [openFileModal, setOpenFileModal] = useState(false);
  const [openUpdateFileModal, setOpenUpdateFileModal] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  console.log("info", selectedTemplate);

  const toggleAlert = (templateInfo) => {
    setSelectedTemplate(templateInfo);
    setOpenAlert((prev) => !prev);
  };

  const toggleFileModal = (templateInfo) => {
    setSelectedTemplate(templateInfo);
    setOpenFileModal((prev) => !prev);
  };
  const toggleUpdateFileModal = (templateInfo) => {
    setSelectedTemplate(templateInfo);
    setOpenUpdateFileModal((prev) => !prev);
  };
  const closeFileModal = () => {
    setSelectedTemplate(null);
    setName("");
    setCategory("");
    setAttachments([]);
    setOpenFileModal((prev) => !prev);
  };
  const closeUpdateFileModal = () => {
    setOpenUpdateFileModal((prev) => !prev);
  };

  const laoding = useSelector((store) => store.view_friends.isLoading);

  async function fetchData() {
    const pageNumber = parseInt(searchParams.get("PageNumber"), 10) || 0;
    const size =
      parseInt(searchParams.get("PageSize"), 10) || Constants.DEFAULT_PAGE_SIZE;
    try {
      setIsLoading(true);
      const response = await Files.getUploadedFiles({
        pageNumber,
        size,
      });

      if (response.code === 200) {
        const { content, totalPages, totalElements, size } = response.data;
        setCurrentPage(pageNumber);
        setSize(size);
        setTimeout(() => {
          setTotalPages(totalPages);
          setTotalElements(totalElements);
          setTemplateData(content);
          setIsLoading(false);
        }, LOADER_DELAY);
      } else {
        console.error("API Error:", response);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Request Error:", error);
    }
  }

  const onSearchClick = (pageNumber, size) => {
    searchParams.set("PageNumber", pageNumber);
    searchParams.set("PageSize", size);
    setSearchParams(searchParams);
    fetchData();
  };

  const onPaginationClick = (page) => {
    searchParams.set("PageNumber", page);
    setSearchParams(searchParams);
    onSearchClick(page, downloadSize);
  };
  const onRefresh = () => {
    fetchData(0, DEFAULT_PAGE_SIZE);
  };

  const onPageSizeClick = (operator) => {
    // const { pageSize } = paginationInfo;
    const newPageSize = performOperation(
      downloadSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    searchParams.set("PageSize", newPageSize);
    setSearchParams(searchParams);
    onSearchClick(0, newPageSize);
  };
  //   const onSendClick = (templateInfo) => {
  //     dispatch({ type: "SET_DOCUMENT_INFO", payload: templateInfo });
  //     navigate("/emailer/templates/add-recipients");
  //   };

  //   const onViewRecipients = (templateInfo) => {
  //     dispatch({ type: "SET_DOCUMENT_INFO", payload: templateInfo });
  //     navigate(`/emailer/templates/recipients/${templateInfo.id}`);
  //   };

  const onDeleteDoc = async (templateInfo) => {
    try {
      setIsLoading(true);
      await Files.deleteDoc(templateInfo?.id);
      toast.show("Document Deleted Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onRefresh();
      }, 2000);
      toggleAlert(templateInfo);
    } catch (error) {
      setIsLoading(false);
      toast.show(error.message, AlertStatus.ERROR);
      console.error("Request Error:", error);
    }
  };

  const onDownload = async (templateInfo) => {
    try {
      setIsLoading(true);
      const response = await Files.downloadDocument(templateInfo?.id);
      window.open(response?.data?.signedS3Url, "_blank");

      toast.show("Document Downloaded Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onRefresh();
      }, 2000);
    } catch (error) {
      setIsLoading(false);
      toast.show(error.message, AlertStatus.ERROR);
      console.error("Request Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchParams]);
  const getRows = (data) =>
    data.map((templateInfo, index) => {
      const serialNumber = index + 1 + currentPage * downloadSize;
      return (
        <TableRow>
          {/* <TableCell>{serialNumber}</TableCell> */}
          {/* <TableCell>{templateInfo.templateName || "-"}</TableCell> */}
          <TableCell>{serialNumber}</TableCell>
          <TableCell sx={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {templateInfo.name || "NA"}
              </Typography>
            </div>
          </TableCell>
          {/* <TableCell>{templateInfo.subject || "NA"}</TableCell> */}
          <TableCell sx={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {templateInfo.category || "NA"}
              </Typography>
            </div>
          </TableCell>
          <TableCell sx={tabelCellWidth.medium}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {templateInfo?.auditFields?.updatedByName || "NA"}
              </Typography>
            </div>
          </TableCell>
          <TableCell sx={{ maxWidth: "7rem" }}>
            <div>
              <Typography style={styles.typoghrphyStyle}>
                {moment(templateInfo?.auditFields?.updatedAt).format(
                  "DD/MM/YYYY, h:mm:ss a"
                ) || "NA"}
              </Typography>
            </div>
          </TableCell>
          <TableCell sx={{ maxWidth: "7rem" }}>
            <Box sx={{ display: "flex", gap: "10px", justifyContent: "left" }}>
              {hasPermission(PERMISSIONS.UPDATE_CONTENT) && (
                <Tooltip
                  title="Update Document"
                  style={{
                    ...style.actionIcon,
                    color: "#8c8c8c",
                  }}
                >
                  <FileUploadIcon
                    fontSize="small"
                    onClick={() => {
                      toggleUpdateFileModal(templateInfo);
                    }}
                    update
                  />
                </Tooltip>
              )}
              <Tooltip
                title="View Template"
                style={{
                  ...style.actionIcon,
                  color: "#8c8c8c",
                }}
              >
                <FileDownloadIcon
                  fontSize="small"
                  onClick={() => {
                    onDownload(templateInfo);
                  }}
                />
              </Tooltip>

              {hasPermission(PERMISSIONS.DELETE_CONTENT) && (
                <Tooltip
                  title="Delete Document"
                  style={{
                    ...style.actionIcon,
                    color: "#8c8c8c",
                  }}
                >
                  <Delete
                    fontSize="small"
                    onClick={() => {
                      toggleAlert(templateInfo);
                    }}
                  />
                </Tooltip>
              )}
            </Box>
          </TableCell>
        </TableRow>
      );
    });
  return (
    <Box sx={style.container}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          paddingBottom: "1rem",
        }}
      >
        {hasPermission(PERMISSIONS.CREATE_CONTENT) && (
          <Button
            style={{ ...CommonStyles.buttonStyle, minWidth: "220px" }}
            label="Upload New Content"
            endIcon={<AddIcon />}
            onClick={toggleFileModal}
          />
        )}
      </Box>
      {TemplateData?.length ? (
        <Box style={style.tableContainer}>
          <Box style={style.tableHeading}>
            <Box style={style.tableTitle}>Available Documents</Box>
            <Box style={style.tableInfo}>
              Total Document: {totalTemplateElements}
            </Box>
          </Box>
          <NewTable
            scrollable
            columns={DOCUMENTS_COL}
            rows={getRows(
              TemplateData,
              currentPage,
              downloadSize,
              hasPermission
              //   navigate
            )}
            // hasAction
            tableBodyTheme="#F6F6F6"
            tableHeadCellStyle={{
              ...style.tableHeadCells,
              textAlign: "left",
            }}
            hasPermission
          />
          <Box style={style.pagination}>
            <Pagination
              totalPages={totalDownloadPages}
              totalResults={totalTemplateElements}
              currentPage={currentPage}
              pageSize={downloadSize}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          </Box>
        </Box>
      ) : (
        !TemplateData?.length &&
        laoding === false && (
          <Box style={style.emptyContainer}>
            <h1 style={style.noDataMsg}>No Results</h1>
          </Box>
        )
      )}
      {isLoading && <Loader />}
      <Alert
        open={openAlert}
        onClose={() => toggleAlert(null)}
        onSubmit={() => onDeleteDoc(selectedTemplate)}
      />
      <FilesModal
        open={openFileModal}
        onClose={closeFileModal}
        selectedDocument={selectedTemplate}
        isLoading={isLoading}
        setAttachments={setAttachments}
        attachments={attachments}
        setName={setName}
        name={name}
        setCategory={setCategory}
        category={category}
        onRefresh={onRefresh}
      />
      <UpdateModal
        open={openUpdateFileModal}
        onClose={closeUpdateFileModal}
        selectedDocument={selectedTemplate}
        isLoading={isLoading}
        setAttachments={setAttachments}
        attachments={attachments}
        onRefresh={onRefresh}
      />
    </Box>
  );
}

export default FilesList;
